import React, { Component } from "react";
import { Modal } from "react-bootstrap";

class AddDetailModal extends Component {

    constructor() {
        super();

        this.state = {

        }

    }

    render() {

        const {
            isOpen,
            onHide,
            goBack,
            onChange,
            GoOffline,
            offlineDetails,
        } = this.props;

        return (

            <Modal
                centered
                size="lg"
                show={isOpen}
                onHide={onHide}
                className="profile-status-modal"
            >
                <Modal.Header>
                    <button onClick={onHide} data-dismiss="modal" aria-label="Close" className="close">
                        <i className="mdi mdi-close"></i>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <h4>We're sorry about your experience.Can we help?</h4>
                    <p>
                        Share more details can help us improve tutor experience.We'd love to talk about
                        what happened and try to help.
                    </p>
                    <textarea
                        onChange={onChange}
                        className="add-details"
                        placeholder="Add Details"
                        value={offlineDetails.moreDetail}
                    />
                    <div className="buttons">
                        <button className="back" onClick={goBack}>
                            <i className="fa fa-angle-left"></i>Back
                        </button>
                        <button
                            className="button"
                            onClick={GoOffline}
                            disabled={ offlineDetails.moreDetail ? false : true }
                        >
                            Go offline
                        </button>
                    </div>
                </Modal.Body>
            </Modal>

        );

    }

}

export default AddDetailModal;